<template>
  <div class="scroll-content" ref="scrollContent">
    <van-tabs type="card" v-model="dateIdent" @click="handelDatePicker">
      <van-tab v-for="item in timeOptions" :title="item" :key="item" />
    </van-tabs>
    <date-range-picker
      style="padding-top: 8px"
      class="date-range-picker"
      v-if="dateIdent == '4'"
      v-model="dateRange"
      @change="handleDateChange"
    />

    <van-cell center class="panel">
      <template #title>
        <van-popover
          v-model="showPopover"
          trigger="click"
          placement="bottom-start"
          :actions="CardData"
          @select="onSelectPoint"
        >
          <template #reference>
            <img src="../../assets/images/format.png" alt="" />
          </template>
        </van-popover>

        <img
          src="../../assets/images/chanpin.png"
          alt=""
          style="margin-left: 15px"
          @click="showProductSelector = true"
        />
      </template>
      <template #right-icon>
        <span style="font-size: 14px">跨账户数据&nbsp;</span>
        <van-switch v-model="checked" size="16" @change="handelCross" />
      </template>
    </van-cell>

    <!-- 动态生成卡片区域 -->
    <div v-if="isLoading" class="loading-container">
      <van-loading type="spinner" />
    </div>
    <div v-else-if="CardData.length == 0" class="empty-container">
      <div>暂无数据</div>
    </div>
    <div v-else>
      <div
        v-for="card in CardData"
        :key="card.value"
        :ref="'card_' + card.value"
        :id="'card-' + card.value"
        class="card-section"
      >
        <div class="core">
          <!-- 卡片标题 -->
          <div class="card-header">
            <div class="card-title">{{ card.productName }}</div>
            <div class="card-actions">
              <van-popover
                v-model="card.showOper"
                trigger="click"
                :actions="operation"
                @select="(value) => handelOperate(value, card)"
              >
                <template #reference>
                  <img src="../../assets/images/more.png" alt="" />
                </template>
              </van-popover>

              <img
                v-if="card.topStory == '1'"
                src="../../assets/images/pin-filled.png"
                alt=""
                @click="handelSticky(card)"
              />
              <img
                v-else
                src="../../assets/images/pin.png"
                alt=""
                @click="handelSticky(card)"
              />
            </div>
          </div>

          <!-- 数据指标 -->
          <div class="card-metrics">
            <div class="metric-header">
              <div class="tag_title">
                <span
                  v-for="(value, idx) in card.agentDataList"
                  :key="value.agentId"
                  :class="card.agentIdx == idx ? 'tags_active' : ''"
                  @click="card.agentIdx = idx"
                  >{{ value.agentName }}</span
                >
              </div>
              <div
                class="tag-actions"
                @click="card.chainShow = !card.chainShow"
              >
                环比
                <span>{{ card.chainShow ? "▼" : "▲" }} </span>
              </div>
            </div>
            <div class="metric-grid">
              <div class="metric-item" @click="handelType(card, '0')">
                <div
                  class="metric-label"
                  :class="card.contentType == '0' ? 'types_active' : ''"
                >
                  消耗金额
                </div>
                <div class="metric-value">
                  {{ card.agentDataList[card.agentIdx]?.consumeAmount || 0 }}
                </div>
              </div>
              <div class="metric-item" @click="handelType(card, '1')">
                <div
                  class="metric-label"
                  :class="card.contentType == '1' ? 'types_active' : ''"
                >
                  激活数
                </div>
                <div class="metric-value">
                  {{ card.agentDataList[card.agentIdx]?.conversion || 0 }}
                </div>
              </div>
              <div class="metric-item" @click="handelType(card, '2')">
                <div
                  class="metric-label"
                  :class="card.contentType == '2' ? 'types_active' : ''"
                >
                  激活单价
                </div>
                <div class="metric-value">
                  {{ card.agentDataList[card.agentIdx]?.conversionCost || 0 }}
                </div>
              </div>
            </div>

            <template v-if="card.chainShow">
              <div class="metric-chain">
                <div class="chain_title">上期</div>
                <div class="chain-actions">
                  <span>{{
                    card.agentDataList[card.agentIdx]?.lastWeekConsumeAmount ||
                    0
                  }}</span>
                  <span>{{
                    card.agentDataList[card.agentIdx]?.lastWeekConversion || 0
                  }}</span>
                  <span>{{
                    card.agentDataList[card.agentIdx]?.lastWeekConversionCost ||
                    0
                  }}</span>
                </div>
              </div>

              <div class="metric-chain">
                <div class="chain_title">环比</div>
                <div class="chain-actions">
                  <span
                    :class="
                      getRingColorClass(
                        card.agentDataList[card.agentIdx]?.ringConsumeAmount
                      )
                    "
                  >
                    {{
                      formatRingValue(
                        card.agentDataList[card.agentIdx].ringConsumeAmount
                      )
                    }}
                  </span>
                  <span
                    :class="
                      getRingColorClass(
                        card.agentDataList[card.agentIdx]?.ringConversion
                      )
                    "
                  >
                    {{
                      formatRingValue(
                        card.agentDataList[card.agentIdx].ringConversion
                      )
                    }}
                  </span>
                  <span
                    :class="
                      getRingColorClass(
                        card.agentDataList[card.agentIdx]?.ringConversionCost
                      )
                    "
                  >
                    {{
                      formatRingValue(
                        card.agentDataList[card.agentIdx].ringConversionCost
                      )
                    }}
                  </span>
                </div>
              </div>
            </template>
          </div>

          <!-- 图表区域 -->
          <div class="chart_area">
            <LineChart v-if="card.chartData" :chart-data="card.chartData" />
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      class="budget-dialog"
      v-model="showDialog"
      show-cancel-button
      @confirm="handleConfirm"
    >
      <div class="dialog-header">
        <div class="dialog-title">排序</div>
      </div>
      <div class="budget-form">
        <van-field
          v-model="currentCard.sorting"
          type="digit"
          placeholder="请输入"
        />
      </div>
    </van-dialog>

    <multi-picker-selector
      :show="showProductSelector"
      :options="allProducts"
      placeholder="选择产品"
      @select="handleProductSelect"
      @close="showProductSelector = false"
    />
  </div>
</template>

<script>
import DateRangePicker from "@/components/DateRangePicker.vue";
import MultiPickerSelector from "@/components/MultiPickerSelector.vue";
import LineChart from "./LineChart.vue";

import {
  ProductData,
  ProductDataDashboard,
  ObtainChartData,
  reviseCardProduct,
  detachCardProduct,
  operationCardProduct,
} from "@/api/modules/home";

export default {
  name: "HomePage",
  components: {
    DateRangePicker,
    MultiPickerSelector,
    LineChart,
  },
  data() {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const todayStr = formatDate(today);
    return {
      dateIdent: 0,
      timeOptions: ["今天", "昨天", "本周", "上周", "自定义"],
      checked: false,
      showPopover: false,
      CardData: [],
      dateRange: {
        startDate: todayStr,
        endDate: todayStr,
      },
      parameter: {
        startDate: todayStr,
        endDate: todayStr,
        dataType: "1", //跨数据账户 1关/0开
        dateType: "2", // 单日/周期对比'1'/自定义时间'2'
        includeFanstop: true, // 仅概览图表开启实耗制粉条
        contentType: "0", // 消耗金额'0'/激活数'1'/激活单价'2'
      },
      allProducts: [],
      operation: [{ text: "排序" }, { text: "移除" }],
      showDialog: false,
      currentCard: {},
      showProductSelector: false,
      isLoading: false,
    };
  },
  async created() {
    try {
      await Promise.all([
        this.loadProducts(), // 加载产品数据
        this.getGeneral(), // 获取卡片数据
      ]);
    } catch (error) {
      console.log();
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 获取产品
    async loadProducts() {
      try {
        const params = {
          pageNo: 1,
          pageSize: 9999,
        };
        const res = await ProductData(params);
        this.allProducts = res.map((item) => ({
          label: item.productName,
          value: item.id,
          checked: item.mark,
        }));
      } catch (error) {
        console.error("获取产品列表出错:", error);
      }
    },
    // 获取卡片数据
    async getGeneral() {
      try {
        this.isLoading = true;
        const res = await ProductDataDashboard(this.parameter);
        this.CardData = res.list.map((item) => ({
          ...item,
          text: item.productName,
          value: item.id,
          agentIdx: 0, // 默认显示第一个渠道
          chainShow: false, // 环比数据是否展开
          contentType: 0, // 内容类型，消耗、激活、激活单价
          showOper: false, // 卡片操作栏
        }));
      } catch (error) {
        this.CardData = []; // 失败时清空数据
      } finally {
        this.isLoading = false;
      }
    },
    // 便捷式日期刷选
    handelDatePicker(name, title) {
      this.dateIdent = name;
      if (title !== "自定义") {
        this.calculateDateRange(name);
      }
    },
    // 计算日期范围
    calculateDateRange(type) {
      const today = new Date();
      const format = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      let start, end;

      switch (type) {
        case 0: // 今天
          start = end = today;
          break;
        case 1: // 昨天
          start = end = new Date(today.getTime() - 86400000);
          break;
        case 2: // 本周
          var weekDay = today.getDay() || 7;
          start = new Date(today.getTime() - (weekDay - 1) * 86400000);
          end = new Date(start.getTime() + 6 * 86400000);
          break;
        case 3: // 上周
          var thisWeekDay = today.getDay() || 7;
          var thisMonday = new Date(
            today.getTime() - (thisWeekDay - 1) * 86400000
          );
          start = new Date(thisMonday.getTime() - 7 * 86400000);
          end = new Date(start.getTime() + 6 * 86400000);
          break;
        default:
          return;
      }
      this.parameter.startDate = format(start);
      this.parameter.endDate = format(end);
      this.dateRange.startDate = this.parameter.startDate;
      this.dateRange.endDate = this.parameter.endDate;

      setTimeout(() => {
        this.getGeneral();
      }, 600);
    },

    // 自定义日期选择日期选择
    handleDateChange(range) {
      this.parameter.startDate = range.startDate;
      this.parameter.endDate = range.endDate;

      setTimeout(() => {
        this.getGeneral();
      }, 600);
    },
    // 跨数据账户
    handelCross(value) {
      this.parameter.dataType = value == true ? "0" : "1";
      setTimeout(() => {
        this.getGeneral();
      }, 600);
    },
    // 切换置顶
    async handelSticky(record) {
      try {
        let params = {
          topStory: record.topStory == 0 ? 1 : 0,
          id: record.id,
        };
        const res = await reviseCardProduct(params);
        this.$toast.success(res.message);
        if (res.result == "true") {
          setTimeout(() => {
            this.getGeneral();
          }, 600);
        }
      } catch (error) {
        console.log("切换置顶失败:", error);
      }
    },
    // 卡片定位
    onSelectPoint(action) {
      this.showPopover = false;
      this.scrollToCard(action.value);
    },
    // 滚动到指定卡片
    scrollToCard(cardId) {
      // 平滑滚动
      const cardElement = document.getElementById(`card-${cardId}`);
      if (cardElement) {
        // 计算需要滚动到的位置（考虑顶部固定区域）
        const scrollContainer = this.$refs.scrollContent;
        const topOffset = 116; // 顶部固定区域高度
        const cardTop = cardElement.offsetTop - topOffset;

        // 平滑滚动
        scrollContainer.scrollTo({
          top: cardTop,
          behavior: "smooth",
        });
      } else {
        console.warn(`未找到卡片: ${cardId}`);
      }
    },
    // 卡片操作（排序、删除）
    handelOperate(action, record) {
      if (action.text == "排序") {
        this.showDialog = true;
        this.currentCard = record;
      }
      if (action.text == "移除") {
        this.$dialog
          .confirm({
            title: "移除",
            message: "是否移除当前产品，不再展示",
          })
          .then(async () => {
            const res = await detachCardProduct({ id: record.id });
            this.$toast.success(res.message);
            if (res.result == "true") {
              setTimeout(() => {
                this.getGeneral();
              }, 600);
            }
          })
          .catch(() => {});
      }
    },
    // 选中产品
    async handleProductSelect(selectedItems) {
      const res = await operationCardProduct(selectedItems);
      this.$toast.success(res.message);
      this.showProductSelector = false; // 选择完成后关闭选择器
      if (res.result == "true") {
        setTimeout(() => {
          this.getGeneral();
        }, 600);
      }
    },

    // 切换 内容类型 （消耗、激活、激活单价）
    async handelType(record, type) {
      record.contentType = type;
      try {
        const res = await ObtainChartData({
          ...this.parameter,
          productId: record.productId,
          contentType: type,
        });
        const cardIndex = this.CardData.findIndex(
          (item) => item.id === record.id
        );
        if (cardIndex !== -1) {
          this.CardData[cardIndex].chartData = res;
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 提交
    async handleConfirm() {
      let params = {
        id: this.currentCard.id,
        sorting: this.currentCard.sorting,
      };
      const res = await reviseCardProduct(params);
      this.$toast.success(res.message);
      if (res.result == "true") {
        setTimeout(() => {
          this.getGeneral();
        }, 600);
      }
    },

    getRingColorClass(value) {
      if (value) {
        const num = parseFloat(value.toString());
        if (num > 0) return "red-text";
        if (num < 0) return "green-text";
      }

      return "";
    },

    formatRingValue(value) {
      if (value) {
        const num = parseFloat(value.toString());
        if (num > 0) return `+${value}%`;
        if (num < 0) return `${value}%`;
      }
      return value;
    },
  },
};
</script>

<style scoped lang="scss">
.red-text {
  color: #ff6151; // 红色
}

.green-text {
  color: #5bc877; // 绿色
}
.scroll-content {
  flex: 1;
  overflow-y: auto;
  margin-top: 106px; /* 顶部固定区域高度 */
  padding: 12px 10px;
  padding-bottom: 70px; /* 底部TabBar高度 */
  box-sizing: border-box;

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
  }

  .empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    color: #999;
    font-size: 14px;
  }

  .card-section {
    margin-bottom: 12px;
    transition: all 0.3s ease;
  }

  .core {
    padding: 12px 8px 4px 8px;
    border-radius: 6px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0), 0 0 9px 0 rgba(0, 0, 0, 0.01),
      0 0 8px 0 rgba(0, 0, 0, 0.05), 0 0 6px 0 rgba(0, 0, 0, 0.09),
      0 0 3px 0 rgba(0, 0, 0, 0.1);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .card-title {
      display: inline-flex;
      padding: 4px 16px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      border-radius: 22px;
      background: #000;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      color: #fff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 600;
    }

    .card-actions {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }
  .card-metrics {
    .metric-header {
      display: flex;
      justify-content: space-between;
      color: #000;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 500;

      .tag_title {
        flex: 1;
        span {
          margin-right: 8px;
          color: #d8d8d8;
          &.tags_active {
            color: #000;
          }
        }
      }
    }

    .metric-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-top: 8px;
      .metric-item {
        text-align: left;
        color: #000;
        font-family: "PingFang SC";
        .metric-label {
          font-size: 12px;
          margin-bottom: 10px;
          color: #999;
          &.types_active {
            color: #000;
          }
        }

        .metric-value {
          font-size: 14px;
          font-weight: 500;
        }
      }
    }

    .metric-chain {
      font-family: "PingFang SC";
      .chain_title {
        color: #999999;
        font-size: 12px;
        margin: 6px 0;
      }
      .chain-actions {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        font-size: 14px;
        color: #000;
        font-weight: 500;
      }
    }
  }

  .chart_area {
    border-radius: 4px;
    width: 100%;
    height: 220px;
  }
}

::v-deep(.van-tabs__nav--card) {
  border-radius: 999px;
  background: #f7f7f7;
  overflow: hidden;
  border: none;
  margin: 0;
  border: 1px solid #f7f7f7;
}
::v-deep(.van-tabs__nav--card .van-tab) {
  border-right: none;
  color: #000000;
}
::v-deep(.van-tabs__nav--card .van-tab.van-tab--active) {
  border-radius: 999px;
  background: #fff;
  color: #000000;
}
::v-deep(.van-cell) {
  line-height: 0;
  &::after {
    border-bottom: none;
  }
}

.panel {
  margin: 8px 0;
  padding: 5px 4px;
  img {
    width: 18px;
    height: 18px;
  }
}

.budget-dialog {
  border-radius: 8px;
  overflow: hidden;
  .dialog-header {
    padding: 16px;
    background: #fff;
    .dialog-title {
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      text-align: center;
      padding-left: 10px;
    }
  }
  .budget-form {
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
    ::v-deep(.van-cell) {
      background: #f3f3f3;
    }
  }
}
</style>
<style lang="scss">
// 强制修改 popover 内容区尺寸
.van-popover__content {
  max-height: 200px !important;
  overflow-y: auto !important;
  margin: 0 !important;
  padding: 8px 0 !important;
}

// 强制修改选项高度
.van-popover__action {
  width: 100px !important;
  height: 30px !important;
  line-height: 30px !important;
  font-size: 14px !important;
  padding: 0 !important;
}

// 箭头样式补充
.van-popover__arrow {
  display: none; /* 可选：隐藏箭头避免样式冲突 */
}
</style>
